export default "__VITE_ASSET__fff87f31__"